// extracted by mini-css-extract-plugin
export default {"wrapper":"Reports_wrapper__q7A3I","sidebarWrapper":"Reports_sidebarWrapper__FLjPw","sectionWrapper":"Reports_sectionWrapper__9m1B9"};